import TrackingSupportIcon from 'assets/dialogue-avatar-tracking-support.svg';
import { DialogueCardData, DialogueType } from 'models/DialogCard';

import { ArrowLink } from './Arrows';

export const INTERNATIONAL_TRACKING_LINK_TEST_ID = 'InternationalTrackingLinkId';

export function getInternationalParcelCard(internationalTrackingLink: string): DialogueCardData | null {
  if (!internationalTrackingLink) return null;

  return {
    analyticsId: 'internationalTrackingUrl',
    type: DialogueType.TRACKING_SUPPORT,
    icon: <TrackingSupportIcon />,
    title: 'More details on international tracking',
    content: (
      <p>
        Now that your parcel has arrived in the destination country, more detailed tracking information is available
        from the international carrier.
      </p>
    ),
    actions: (
      <ArrowLink href={internationalTrackingLink} target='_blank' data-testid={INTERNATIONAL_TRACKING_LINK_TEST_ID}>
        Track parcel with international carrier
      </ArrowLink>
    ),
  };
}
